import { moduleLoadFailed, moduleLoadStarted, moduleLoaded } from '@invent/module-federation';
import type { WidgetLoadActivity } from './types';

/**
 * Widget deliveries, from the loader's own events: once per load of an exposed module,
 * parallel instances being one load. A load of a remote already initialised on the page
 * (`remoteEntryReady`: a tile mounted again, served from webpack's cache) is no delivery
 * and gets no entry, a dashboard re-rendering ten tiles would fill the ring with them;
 * its failure is still one. Returns the function that unsubscribes.
 */
export function observeWidgetLoads(
  record: (entry: WidgetLoadActivity) => void,
  now: () => number = Date.now
): () => void {
  const subscriptions = [
    moduleLoadStarted.watch(({ scope, remoteEntryReady }) => {
      if (!remoteEntryReady) {
        record({ kind: 'load', time: now(), scope, event: 'started' });
      }
    }),
    moduleLoaded.watch(({ scope, elapsedMs, remoteEntryReady }) => {
      if (!remoteEntryReady) {
        record({ kind: 'load', time: now(), scope, event: 'loaded', elapsedMs });
      }
    }),
    moduleLoadFailed.watch(({ scope, elapsedMs, stage }) => {
      record({ kind: 'load', time: now(), scope, event: 'failed', elapsedMs, stage });
    })
  ];
  return () => {
    subscriptions.forEach((subscription) => subscription.unsubscribe());
  };
}
